import { useGetAgentListAgentListGetQuery } from '@shared/api';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';
import { useEffect, useRef } from 'react';

export const useGetAgents = () => {
  const organizationId = useAppSelector(authSelectors.selectCurrentOrganizationId);
  const prevOrganizationIdRef = useRef(organizationId);

  const { data, isLoading, isFetching, isError, refetch } = useGetAgentListAgentListGetQuery(
    {
      organizationId,
    },
    {
      skip: !organizationId,
      refetchOnMountOrArgChange: true,
    },
  );

  useEffect(() => {
    if (!organizationId) return;
    if (prevOrganizationIdRef.current === organizationId) return;

    prevOrganizationIdRef.current = organizationId;
    refetch();
  }, [organizationId, refetch]);

  const isEmpty = !data || data.length === 0;
  const count = data?.length ?? 0;

  return {
    agents: data,
    count,
    isEmpty,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
